import { IBuilderModel } from '../models/workflow-builder.model';
import {
  executionAwareHorizontalLayout,
  executionAwareVerticalLayout,
} from './workflow-execution-layout';

export type WorkflowLayoutDirection = 'vertical' | 'horizontal';
export type WorkflowPositions = Record<string, { x: number; y: number }>;

export async function autoLayoutWorkflow(
  model: IBuilderModel,
  direction: WorkflowLayoutDirection,
  sizeFor: (stateCode: string) => { width: number; height: number } = () => ({
    width: 258,
    height: 120,
  })
): Promise<WorkflowPositions> {
  if (direction === 'vertical') {
    return executionAwareVerticalLayout(model, nodeKey => sizeFor(nodeKey));
  }
  return executionAwareHorizontalLayout(model, nodeKey => sizeFor(nodeKey));
}
